var React = require('react');

function Tag (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M2.856 1h4.082c.196 0 .386.078.524.218l7.32 7.32a.74.74 0 0 1 0 1.05l-5.194 5.195c-.29.29-.76.29-1.05 0l-7.32-7.321A.737.737 0 0 1 1 6.938V2.856C1 1.83 1.83 1 2.856 1zm.99 4.01a1.311 1.311 0 1 0 0-2.623 1.311 1.311 0 0 0 0 2.623z"}));
}

Tag.defaultProps = {"viewBox":"0 0 16 16"};

module.exports = Tag;

Tag.default = Tag;
